import React from 'react'
import styled from '@emotion/styled'
import { colors, radius, shadow, spacing } from '@mobi/component-library/Foundations'
import type { KambiHistoryCoupon } from '@mobi/api-types/kambi'
import type { Ticket } from '@core/Areas/AccountActivity/types'
import { BetInfo } from '@core/Areas/AccountActivity/Components/Ticket/Components/BetInfo'
import { BetInfo as KambiBetInfo } from '@core/Areas/KambiSports/Components/BetHistory/BetInfo'
import { TicketDisplayContext } from '@core/Areas/AccountActivity/context'
import { getTicketLayoutType } from '@core/Areas/AccountActivity/Components/Ticket/helpers/legTypes'
import { KambiHistoryCouponDisplayContext } from '@core/Areas/KambiSports/Components/BetHistory/context'
import { isKambiSharedCoupon } from '@core/Areas/BetLoop/helpers/typeGuards/isKambiSharedCoupon'

export const PendingTicket: React.FC<{
  ticket: Ticket | KambiHistoryCoupon
  isSelected: boolean
  onClick(ticketSequence: Ticket['ticketSequence']): void
}> = ({ ticket, isSelected, onClick }) => {
  const isKambiBet = isKambiSharedCoupon(ticket)
  const ticketNumber = isKambiBet ? ticket.bets[0].betRef : ticket.ticketSequence

  return (
    <WrapperStyled
      onClick={() => onClick(ticketNumber)}
      className={isSelected ? 'quick-share__ticket--selected' : ''}
    >
      {isKambiBet ? (
        <KambiHistoryCouponDisplayContext.Provider
          value={{ type: 'betloop-quick-share', data: { isSelected } }}
        >
          <div>
            <KambiBetInfo historyCoupon={ticket} />
          </div>
        </KambiHistoryCouponDisplayContext.Provider>
      ) : (
        <TicketDisplayContext.Provider
          value={{
            type: 'share',
            data: { shouldHideCost: true, display: 'betloop-quick-share', isSelected },
          }}
        >
          <div>
            <BetInfo
              ticket={ticket}
              status='Pending'
              ticketLayoutType={getTicketLayoutType(ticket)}
            />
          </div>
        </TicketDisplayContext.Provider>
      )}
    </WrapperStyled>
  )
}

// ======
// Styles
// ======

const WrapperStyled = styled.button({
  position: 'relative',
  padding: '0.6rem',
  background: colors.white,
  borderRadius: radius.lgx2,
  border: `0.1rem solid ${colors.neutral[200]}`,
  boxShadow: shadow.xs,
  cursor: 'pointer',
  textAlign: 'unset',
  transition: 'all 0.3s ease',
  WebkitTapHighlightColor: 'transparent',

  '::before': {
    content: '""',
    position: 'absolute',
    inset: 0,
    transition: 'opacity 0.3s ease',
    borderRadius: 'inherit',
    border: `0.2rem solid ${colors.studio[500]}`,
    opacity: 0,
  },

  '&.quick-share__ticket--selected': {
    background: colors.lavender[50],

    '::before': { opacity: 1 },
  },

  '> div': {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.smx1,
    padding: '0.6rem',
    background: 'white',
    borderRadius: radius.lgx1,

    // Disable all interaction w/ display ticket
    pointerEvents: 'none',
  },
})
